import { z } from 'zod';

export const annotationObjectZod = z.object({
  token: z.string(),
  sampleGroupToken: z.string(),
  categoryToken: z.string(),
  referenceId: z.string(),
  name: z.string().nullable(),
  tag: z.string().nullable(),
  enriched: z.boolean().nullable(),
});
export const annotationObjectRespZod = z.array(annotationObjectZod);
export type AnnotationObject = z.infer<typeof annotationObjectZod>;
export type AnnotationObjectResp = z.infer<typeof annotationObjectRespZod>;
